import { useLocation } from 'lib/router'

const useQueryParam = () => {
  return new URLSearchParams(useLocation().search)
}

export default useQueryParam
